import axios from 'axios';
import { API_AUTH_TOKEN, API_DOMAIN } from '../EnvVars';

const domains = {
  apiMyManage: API_DOMAIN,
};

const services = {
  dealerep: '/api/dealerep',
  bookingep: '/api/bookingep',
  auth: '/api/authserver/oauth',
};

let authToken;
let userRoles;

const getResponse = service => endpoint => (queryStringParams, cancelable = false) => {
  if (cancelable && tokenSource !== undefined) {
    //tokenSource.cancel("Operation canceled due to new request.");
  }

  // save the new request for cancellation
  if (cancelable) tokenSource = axios.CancelToken.source();

  const params = queryStringParams ? new URLSearchParams(queryStringParams).toString() : '';

  return axios
    .get(domains.apiMyManage + service + endpoint + `${params ? '?' + params : ''}`, {
      headers: { Authorization: localStorage.getItem('authToken') },
    })
    .then(res => {
      return res.data;
    });
};

const getAPIAuthToken = (userName, password) => {
  const clientId = API_AUTH_TOKEN;
  const header = { Authorization: `Basic ${btoa(`${userName}:${password}`)}` };
  const getAPIAuthTokenRequest = () =>
    axios.post(`${clientId}?grant_type=client_credentials`, {}, { headers: header });

  return new Promise((resolve, reject) => {
    getAPIAuthTokenRequest()
      .then(response => {
        authToken = response.data;
        resolve(response.data);
      })
      .catch(error => {
        reject(Error('login ' + error));
      });
  });
};

const postResponse = service => endpoint => (body, cancelable = false) => {
  if (cancelable && tokenSource !== undefined) {
    //tokenSource.cancel("Operation canceled due to new request.");
  }

  // save the new request for cancellation
  if (cancelable) tokenSource = axios.CancelToken.source();

  return axios
    .post(domains.apiMyManage + service + endpoint, body, {
      headers: { Authorization: localStorage.getItem('authToken') },
    })
    .then(res => res.data);
};

const putResponse = service => endpoint => (body, cancelable = false) => {
  if (cancelable && tokenSource !== undefined) {
    //tokenSource.cancel("Operation canceled due to new request.");
  }

  // save the new request for cancellation
  if (cancelable) tokenSource = axios.CancelToken.source();

  return axios
    .put(domains.apiMyManage + service + endpoint, body, {
      headers: { Authorization: localStorage.getItem('authToken') },
    })
    .then(res => res.data);
};

const patchResponse = service => async (url, params, cancelable = false) => {
  if (cancelable && tokenSource !== undefined) {
  }
  if (cancelable) tokenSource = axios.CancelToken.source();

  const res = await axios
    .patch(domains.apiMyManage + service + url, params, {
      headers: { Authorization: localStorage.getItem('authToken') },
      cancelToken: cancelable ? tokenSource.token : undefined,
    });
  return res.data;
};

export default class Api {
  static login = (userName, password) => getAPIAuthToken(userName, password);

  static getUseRoles = () => getResponse(services.dealerep)('/user/roles')();

  static getDms = () => getResponse(services.dealerep)('/dms')({});

  static getEnvironmentData = () =>
    getResponse(services.bookingep)('/myManage/failedBookingTransactions')({});

  static cleanCache = type => postResponse(services.bookingep)('/cache/clear')([type]);

  static getAllFeatures = () => getResponse(services.dealerep)('/feature/all')({});

  static getDealerFeature = () => getResponse(services.dealerep)('/dealers/locations/features')({});

  static updateDealer = params =>
    putResponse(services.dealerep)('/dealers/features/update')(params);

  static updateFailedBookingTransaction  = params => {
    const { uuid } = params; // Extract uuid from params
    const url = `/myManage/updatefailedBookingTransaction/${uuid}`; // Construct URL using uuid
    return patchResponse(services.bookingep)(url, params); // Use PATCH method and send the payload
  };

  static updateFailedBookingTransactionWithBookingId  = params => {
    const { uuid, bookingId } = params; // Extract uuid and bookingId from params
    const url = `/myManage/updatefailedBookingTransactionWithBookingId/${uuid}/${bookingId}`; // Construct URL using both uuid and bookingID
    return patchResponse(services.bookingep)(url, {}); // Use PATCH method and send the payload
  };

  static updateDealerLocationName = params =>
    putResponse(services.dealerep)('/dealers/location/name/update')(params);

  static getAuditDetails = params =>
    getResponse(services.dealerep)('/dealers/feature/location/auditdetails')(params);

  static getBookingUrl = params => getResponse(services.bookingep)('/deeplink/dms/booking')(params);
}



// WEBPACK FOOTER //
// ./src/api/api.js